import i18n from 'modules/core/lib/i18n'
import { joinAsSentence } from 'modules/core/lib/stringUtils'

import type { FieldType } from 'modules/reports/components/Editor/Field/types'
import { TYPES } from 'modules/reports/lib/Constants'
import type ConditionForm from 'modules/reports/lib/Store/FormCollections/Filter/Condition/ConditionForm'
import Condition from 'modules/reports/store/models/Condition'

import checkbox from './checkbox'
import dayOfWeek from './dayOfWeek'
import documentCategory from './documentCategory'
import employeeGender from './employeeGender'
import employeeStatus from './employeeStatus'
import leaveTypes from './leaveTypes'
import surveysAnonymous from './surveysAnonymous'
import surveysQuestionStatus from './surveysQuestionStatus'

function justNull(list: string[]) {
  const label = i18n.t('custom_reports.especial_filters.not_defined')

  return list.map((value: string) => {
    if (value === Condition.NOT_DEFINED) return label

    return value
  })
}

const TRANSFORMERS: Record<string, (list: string[]) => string[]> = {
  'employee.gender': employeeGender,
  'employee.status': employeeStatus,
  'employee.office': justNull,
  'employee.team': justNull,
  'employee.working_days': dayOfWeek,
  'document.type': documentCategory,
  'leave.type': leaveTypes,
  'surveys_question_group.anonymous': surveysAnonymous,
  'surveys_question_group.question_status': surveysQuestionStatus,
}

function transform(list: string[], path: string): string[] {
  const func = TRANSFORMERS[path]

  if (!func) return list

  return func(list)
} // FIXME: What exactly does this method? why we need it?

export default function transformArguments(fieldType: FieldType): string | undefined {
  const { form, field } = fieldType

  // FIXME We shouldn't be transforming this?
  const list = (form as ConditionForm).arguments.map((arg) => {
    return arg.value
  })

  if (list.length < 1) return ''

  if (!field) return ''

  if (field.attributes.type === TYPES.checkbox) return checkbox(list)[0]

  return joinAsSentence(transform(list, field.get('path') ?? ''))
}
